import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Fees } from './models/fees/fees';
import { FeesCollected } from './models/fees/fees-collected';
import { FeeBasicInfoCreateInterface } from './models/fees/fee-basic-info-create-interface';
import { FeeBillingInfo } from './interfaces/fee-billing-info';
import { FeeStructure } from './interfaces/fee-structure';
import { StateList } from './interfaces/state-list';
import { EditFeePlanDetails } from './interfaces/edit-fee-plan-details';
import { EditFeePlan } from './interfaces/edit-fee-plan';
import { TeamFeeAssign } from './models/team-fee-assign';
import { HttpService } from './services';

@Injectable()
export class FeesService {

  private _url = '/api/Fees/';

  constructor(
    private http: HttpClient,
    private httpService: HttpService
  ) { }

  getFeesData(program_id, teamId = 0): Observable<Fees[]> {
    let url = this._url + 'program-fees/' + program_id;
    if (teamId > 0) {
      url += '?teamId=' + teamId;
    }
    return this.http.get<Fees[]>(url);
  }

  getFeesCollegedData(program_id): Observable<FeesCollected[]> {
    return this.http.get<FeesCollected[]>(this._url + 'program-fees-collected/' + program_id);
  }
  // get-fee-gender-team-list/{assignFee}/{clubProgramFeeGender}/{clubProgramID}
  getFeeTeams(clubProgramFeeGender: string, clubID: string | number, teamId: number = 0): Observable<any[]> {
    let url = this._url + 'get-fee-gender-team-list/' + clubProgramFeeGender + '/' + clubID;
    if (teamId > 0) {
      url += '?teamId=' + teamId;
    }
    return this.http.get<TeamFeeAssign[]>(url);
  }


  assignFeeTeams(clubProgramFeeID: string, selectedPreferences: number[]): any {
    console.log('Selected Preferences - ', selectedPreferences);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + 'feeAssignmentTeam/' + clubProgramFeeID, selectedPreferences, httpOptions);
  }

  assignFeeUsers(clubProgramFeeID: string, userIds: number[], clubId: number): any {
    return this.httpService.post(`${this._url}feeAssignmentUsers/${clubProgramFeeID}/${clubId}`, userIds);
  }

  getAlreadyAssignedTeams(feeId: any): Observable<any[]> {
    return this.http.get<number[]>(this._url + 'get-already-assigned-teams/' + feeId);
  }

  getAlreadyAssignedUsers(feeId: any): Observable<any[]> {
    return this.http.get<number[]>(this._url + 'get-already-assigned-users/' + feeId);
  }


  createBasicFeeInfo(feeBasicInfo: FeeBasicInfoCreateInterface) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + 'basicfee', feeBasicInfo, httpOptions);
  }

  saveBillingInfo(feeBillingInfo: FeeBillingInfo) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + 'billingInfo', feeBillingInfo, httpOptions);
  }

  saveFeeStructure(feeStructure: FeeStructure) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + 'create-paymentplanonly', feeStructure, httpOptions);
  }

  saveFullPay(payment: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + 'create-paymentplanonly', payment, httpOptions);
  }

  deleteFees(fee_ids: string) {
    return this.http.delete(this._url + 'delete-fees/' + fee_ids);
  }

  getFees(fee_ids: string) {
    return this.http.get<FeeBasicInfoCreateInterface>(this._url + 'show-fee-new/' + fee_ids);
  }

  getFeeGender(fee_ids: string) {
    return this.http.get<string>(this._url + 'get-fee-gender/' + fee_ids);
  }

  getStates(): Observable<StateList[]> {
    return this.http.get<StateList[]>('api/State');
  }

  deleteFeePaymentPlan(clubFeePaymentPlanID: number) {
    return this.http.delete(this._url + 'delete-feePaymentPlan/' + clubFeePaymentPlanID);
  }

  updateStatusFeePaymentPlan(clubFeePaymentPlanID: number, isEnabled: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + 'update-status-feePaymentPlan/' + clubFeePaymentPlanID + '/' + isEnabled, httpOptions);
  }

  /* Get fee plan details. */
  getFeePlanDetails(clubFeePaymentPlanID: number): Observable<EditFeePlanDetails[]> {
    return this.http.get<EditFeePlanDetails[]>(this._url + 'get-feePaymentPlan/' + clubFeePaymentPlanID);
  }

  /* Update Fee Plan */
  updateFeeStructure(editFeePlan: EditFeePlan) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + 'update-paymentplanonly', editFeePlan, httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/fees.service.ts